import React, { useEffect, useState } from "react";
import { useAuth } from "../context/API_Client";
import { useNavigate, Link } from "react-router-dom";
import {
  Alert,
  Breadcrumbs,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { GoDotFill } from "react-icons/go";
import "../../components/css/style.css";
import MenuIcon from "@mui/icons-material/Menu";
import { isSidebarCollapsed, toggleSidebarCollapsed } from "./Utils";
import SetupProfileToolTip from "./adminProfile/SetupProfileToolTip";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { isMasqueradeUrl } from "./utils/utils";
import ProfileIcon from "../../assets/svg/Profile.svg";
import { colorBrandObject } from "../../constants/brandings";
import { iconDefaultColor } from "../reusableComponents/constants";

const Header = () => {
  const { logout, getUserDetails } = useAuth();
  const navigate = useNavigate();

  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(isSidebarCollapsed);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    toggleSidebarCollapsed(!sidebarCollapsed);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1000px)");
    setMobileNavbar(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setMobileNavbar(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/settings") {
      window.location.pathname = "/settings/business_unit";
    }

    if (window.location.pathname === "/developers") {
      window.location.pathname = "/developers/api_credentials";
    }
  }, []);

  const handleLogout = () => {
    try {
      navigate('/')
      logout();

    } catch (error) { }
  };

  function getLastPart(url) {
    var parts = url.split("/");
    return url.lastIndexOf("/") !== url.length - 1
      ? parts[parts.length - 1]
      : parts[parts.length - 2];
  }

  const handleBreadCrumbs = (currentUrl, linkUrl, title, last) => {
    let include = window.location.href.includes(currentUrl);
    let atLast = getLastPart(window.location.href);

    if (include) {
      if (atLast.includes(last)) {
        return (
          <span
            style={{ color: "black", cursor: "default", marginRight: "4px" }}
          >
            {title}
          </span>
        );
      } else {
        return (
          <Link to={linkUrl} style={{ color: "black", marginRight: "4px" }}>
            {title}
          </Link>
        );
      }
    } else {
      return <></>;
    }
  };

  const breadCrumbs = [
    {
      url: "/config/add_payment_gateways",
      crumbs: [
        {
          Configurations: "/config",
          "Add Payment Gateways": "/config/add_payment_gateways",
        },
      ],
    },
  ];

  const [selectedEnv, setSelectedEnv] = useState("");
  useEffect(() => {
    setSelectedEnv(window.location.hostname.split(".")[0]);
  }, []);
  var profile = "admin";
  // var profile="user"

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {isMasqueradeUrl() && (
        <Alert
          icon={false}
          sx={{
            position: "fixed",
            top: -25,
            left: "50%",
            transform: "translate(-50%, 0)",
          }}
          className="alert-red"
        >
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <img
              src="/assets/warningSignRed.svg"
              style={{
                width: "24px",
                paddingTop: "0px",
              }}
            />

            <div
              style={{
                marginLeft: "4px",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: "500",
                paddingTop: "2px",
              }}
            >
              Masquerade Session. Please don't make any changes.
            </div>
          </div>
        </Alert>
      )}
      {mobileNavbar && (
        <div
          data-widget="pushmenu"
          role="button"
          onClick={handleSidebarToggle}
          style={{ marginBottom: "0px !important" }}
        >
          <MenuIcon sx={{ height: "24px", width: "24px" }} />
        </div>
      )}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link"></a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <Breadcrumbs aria-label="breadcrumb" className="header-breadcrumb">
            <Typography color="text">
              {handleBreadCrumbs("/reconciliation/files", "/reconciliation/files", "Upload Files", "Upload Files")}
              {handleBreadCrumbs("/home", "/home", "Home", "home")}
              {handleBreadCrumbs(
                "/payment_gateway_configurations",
                "/payment_gateway_configurations",
                "Configurations",
                "payment_gateway_configurations"
              )}
              {handleBreadCrumbs(
                "/payment_gateway_configurations/add_payment_gateways",
                "/payment_gateway_configurations/add_payment_gateways",
                "/ Add Payment Gateways",
                "add_payment_gateways"
              )}
              {handleBreadCrumbs(
                "/transactions",
                "/transactions",
                "Transactions",
                "orderManagement"
              )}
              {handleBreadCrumbs(
                "/transacs/payment_details/transaction_Details",
                "/transactions",
                "Transactions",
                "orderManagement"
              )}

              {handleBreadCrumbs(
                "/transacs/payment_details/transaction_Details",
                "/transacs/payment_details/transaction_Details",
                "/ Transaction Details",
                "order_Details"
              )}

              {handleBreadCrumbs(
                "/transactions/batchRefund",
                "/transactions/batchRefund",
                "/ Batch Refund",
                "batchRefund"
              )}
              {handleBreadCrumbs("/routing", "/routing", "Routing", "routing")}

              {handleBreadCrumbs(
                "/routing/updateRoutingRule",
                "/routing/updateRoutingRule",
                "/ Update Routing Rule",
                "updateRoutingRule"
              )}
              {handleBreadCrumbs(
                "/routing/createRoutingRule",
                "/routing/createRoutingRule",
                "/ Create Routing Rule",
                "createRoutingRule"
              )}
              {handleBreadCrumbs(
                "/checkout",
                "/checkout",
                "Checkout",
                "checkout"
              )}
              {handleBreadCrumbs(
                "/paymentReconciliation",
                "/paymentReconciliation",
                "Reconciliation",
                "reconciliation"
              )}
              {handleBreadCrumbs(
                `/reconciliation/${getLastPart(window.location.href)}`,
                `/reconciliation/${getLastPart(window.location.href)}`,
                "Reconciliation",
                "reconciliation"
              )}
              {handleBreadCrumbs(
                "/developers/api_credentials",
                "/developers/api_credentials",
                "API Credentials",
                "api_credentials"
              )}

              {handleBreadCrumbs("/reports", "/reports", "Reports", "reports")}

              {handleBreadCrumbs(
                "/reports/createReport",
                "/reports/createReport",
                "/ Generate Report",
                "createReport"
              )}

              {handleBreadCrumbs(
                "/reports/gmv",
                "/reports/gmv",
                "/ GMV Reports",
                "gmv"
              )}

              {handleBreadCrumbs(
                "/analytics",
                "/analytics",
                "Analytics",
                "analytics"
              )}

              {handleBreadCrumbs("/demo", "/demo", "Demo", "demo")}
              {handleBreadCrumbs(
                "/demo/simulator",
                "/demo/simulator",
                "Simulator",
                "simulator"
              )}
              {handleBreadCrumbs(
                "/adminProfile",
                "/adminProfile",
                "Profile",
                "adminProfile"
              )}

              {handleBreadCrumbs(
                "/userProfile",
                "/userProfile",
                "Profile",
                "userProfile"
              )}

              {handleBreadCrumbs(
                "/paymentLinks",
                "/paymentLinks",
                "Payment Links",
                "paymentLinks"
              )}
              {handleBreadCrumbs(
                "/paymentLinks/createPaymentlink",
                "/paymentLinks/createPaymentlink",
                "/ Create Payment Link",
                "createPaymentlink"
              )}



              {handleBreadCrumbs(
                "/offerManagement",
                "/offerManagement",
                "Offer Management",
                "offerManagement"
              )}
              {handleBreadCrumbs(
                "/approvals",
                "/approvals",
                "Approval Requests",
                "Approval Requests"
              )}

              {handleBreadCrumbs(
                "/approvals/detail",
                "/approvals/detail",
                "/ Approval Details",
                "detail"
              )}

              {handleBreadCrumbs(
                "/offerManagement/createEmiOffer",
                "/offerManagement/createEmiOffer",
                "/ Create EMI Offer",
                "createEmiOffer"
              )}
              {handleBreadCrumbs(
                "/offerManagement/editEmiOffer",
                "/offerManagement/editEmiOffer",
                "/ Edit EMI Offer",
                "editEmiOffer"
              )}

              {handleBreadCrumbs(
                "/paymentLinks/editPaymentlink",
                "/paymentLinks/editPaymentlink",
                "/ Edit Payment Link",
                "editPaymentlink"
              )}

              {handleBreadCrumbs(
                "/settings/business_unit",
                "/settings/business_unit",
                "Business Units",
                "business_unit"
              )}

              {handleBreadCrumbs(
                "/settings/product_catalogue",
                "/settings/product_catalogue",
                "Product Catalogue",
                "business_unit"
              )}

              {handleBreadCrumbs(
                "/settings/manageTeam",
                "/settings/manageTeam",
                "Manage Team",
                "manageTeam"
              )}

              {handleBreadCrumbs(
                "/settings/manageTeam/createRole",
                "/settings/manageTeam/createRole",
                "/ Create Role",
                "createRole"
              )}

              {handleBreadCrumbs(
                "/settings/manageTeam/editRole",
                "/settings/manageTeam/editRole",
                "/ Edit Role",
                "editRole"
              )}

              {handleBreadCrumbs(
                "/reports/success_rate",
                "/reports/success_rate",
                "/ Success Rate Reports",
                "success_rate"
              )}

              {handleBreadCrumbs(
                "/reports/trans_state",
                "/reports/trans_state",
                "/ Transaction Stats Reports",
                "trans_state"
              )}
              {handleBreadCrumbs(
                "/developers/webhooks",
                "/developers/webhooks",
                "Webhook",
                "webhooks"
              )}
              {handleBreadCrumbs(
                "/developers/webhooks/createWebhook",
                "/developers/webhooks/createWebhook",
                "/ Create Webhook",
                "createWebhook"
              )}
              {handleBreadCrumbs(
                "/developers/webhooks/editWebhook",
                "/developers/webhooks/editWebhook",
                "/ Edit Webhook",
                "editWebhook"
              )}
              {handleBreadCrumbs(
                "/developers/webhooks/webhookDetail",
                "/developers/webhooks/webhookDetail",
                "/ Webhook Detail",
                "webhookDetail"
              )}
              {handleBreadCrumbs(
                "/developers/webhooks/notifications_Details",
                "/developers/webhooks/notifications_Details",
                "/ Notification ID",
                "notifications_Details"
              )}
            </Typography>
          </Breadcrumbs>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto" style={{ display: "flex" }}>
        {selectedEnv === "localhost" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#FBEFCB",
              borderRadius: "6px",
              padding: "5px 12px",
              marginRight: "32px",
            }}
          >
            <GoDotFill
              style={{ color: "#FA8C16", height: "14px", width: "14px" }}
            />
            <Typography
              style={{
                marginLeft: "4px",
                color: "var(--character-primary-85, rgba(0, 0, 0, 0.85))",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: 400,
                marginRight: "6px",
              }}
            >
              Localhost
            </Typography>
          </div>
        )}
        {(selectedEnv === "sandbox-merchant" ||
          selectedEnv === "masquerade-sandbox-merchant") && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#FBEFCB",
                borderRadius: "6px",
                padding: "5px 12px",
                marginRight: "32px",
              }}
            >
              <GoDotFill
                style={{ color: "#FA8C16", height: "14px", width: "14px" }}
              />
              <Typography
                style={{
                  marginLeft: "4px",
                  color: "var(--character-primary-85, rgba(0, 0, 0, 0.85))",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  marginRight: "6px",
                }}
              >
                Sandbox
              </Typography>
            </div>
          )}

        {(selectedEnv === "test-merchant" ||
          selectedEnv === "masquerade-test-merchant") && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#FBEFCB",
                borderRadius: "6px",
                padding: "5px 12px",
                marginRight: "32px",
              }}
            >
              <GoDotFill
                style={{ color: "#FA8C16", height: "14px", width: "14px" }}
              />
              <Typography
                style={{
                  marginLeft: "4px",
                  color: "var(--character-primary-85, rgba(0, 0, 0, 0.85))",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  marginRight: "6px",
                }}
              >
                Test
              </Typography>
            </div>
          )}
        {(selectedEnv === "merchant" ||
          selectedEnv === "masquerade-merchant") && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "var(--Comms-Positive-sub, #D5FBD2)",
                borderRadius: "6px",
                padding: "5px 12px",
                marginRight: "32px",
              }}
            >
              <GoDotFill
                style={{ color: "#52C41A", height: "14px", width: "14px" }}
              />
              <Typography
                style={{
                  marginLeft: "4px",
                  color: "var(--character-primary-85, rgba(0, 0, 0, 0.85))",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  marginRight: "6px",
                }}
              >
                Production
              </Typography>
            </div>
          )}
        <li className="nav-item dropdown user-menu">
          <a
            style={{
              height: "40px",
              width: "40px",
              backgroundColor:
                "var(--background-disabled, rgba(1, 1, 2, 0.04))",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "20px",
            }}
            href="#"
            className="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <div style={{ stroke: iconDefaultColor }}>
              <ProfileIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
            </div>
          </a>
          <ul
            className="dropdown-menu dropdown-menu-right"
            style={{ marginRight: "30px" }}
          >
            {profile === "admin" ? (
              <>
                {window.location.href.includes("/adminProfile") && (
                  <li className="nav-item menu-is-opening menu-open">
                    <Link
                      style={{
                        color: "grey",
                        display: "flex",
                        alignItems: "center",
                      }}
                      to="/adminProfile"
                      className="nav-link2 active"
                    >
                      <AccountCircleIcon
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "10px",
                        }}
                      />
                      <span>
                        {" "}
                        <Typography
                          style={{
                            marginTop: "15px",
                            marginLeft: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          Profile
                        </Typography>{" "}
                      </span>
                    </Link>
                  </li>
                )}
                {!window.location.href.includes("/adminProfile") && (
                  <li className="nav-item">
                    <Link
                      to="/adminProfile"
                      className="nav-link2"
                      style={{ color: "grey" }}
                    >
                      <AccountCircleIcon
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "10px",
                        }}
                      />
                      <Typography
                        style={{
                          marginTop: "15px",
                          marginLeft: "4px",
                          marginBottom: "14px",
                        }}
                      >
                        Profile
                      </Typography>
                    </Link>
                  </li>
                )}
              </>
            ) : (
              <>
                {window.location.href.includes("/userProfile") && (
                  <li className="nav-item menu-is-opening menu-open">
                    <Link
                      style={{
                        color: "grey",
                        display: "flex",
                        alignItems: "center",
                      }}
                      to="/userProfile"
                      className="nav-link2 active"
                    >
                      <AccountCircleIcon
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "10px",
                        }}
                      />
                      <Typography
                        style={{
                          marginTop: "15px",
                          marginLeft: "4px",
                          marginBottom: "14px",
                        }}
                      >
                        Profile
                      </Typography>
                    </Link>
                  </li>
                )}
                {!window.location.href.includes("/userProfile") && (
                  <li className="nav-item">
                    <Link
                      to="/userProfile"
                      className="nav-link2"
                      style={{ color: "grey" }}
                    >
                      <AccountCircleIcon
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "10px",
                        }}
                      />
                      <Typography
                        style={{
                          marginTop: "15px",
                          marginLeft: "4px",
                          marginBottom: "14px",
                        }}
                      >
                        Profile
                      </Typography>
                    </Link>
                  </li>
                )}
              </>
            )}

            <div
              className="nav-item menu-is-opening menu-open"
              onClick={handleLogout}
            >
              <span
                style={{
                  color: "grey",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer"
                }}
                to="../"
                className="nav-link2"
              >
                <LogoutIcon
                  style={{
                    height: "20px",
                    width: "20px",
                    marginLeft: "10px",
                  }}
                />
                <Typography
                  style={{
                    marginTop: "15px",
                    marginLeft: "4px",
                    marginBottom: "14px",
                  }}
                >
                  Logout
                </Typography>
              </span>
            </div>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
